import { type ApolloError, useSubscription } from '@apollo/client'

import logger from '@/utils/logger'

import { useUser } from '@/client/context/user'
import { useIsPageVisible } from '@/client/hooks'
import type {
  JoinBreakoutSessionSubscription,
  JoinBreakoutSessionSubscriptionVariables,
} from '@/client/services/hasura/generated/graphql'

import { JOIN_BREAKOUT_SESSION_SUBSCRIPTION } from './useRealtimeJoinBreakoutSession.hasura'

export default function useRealtimeJoinBreakoutSession(sessionId: number): {
  loading: boolean
  error: ApolloError | null
  registration: JoinBreakoutSessionSubscription['session_registration'][number] | null
} {
  const user = useUser()
  const isPageVisible = useIsPageVisible()

  const { loading, error, data } = useSubscription<
    JoinBreakoutSessionSubscription,
    JoinBreakoutSessionSubscriptionVariables
  >(JOIN_BREAKOUT_SESSION_SUBSCRIPTION, {
    variables: {
      sessionId,
      currentUserId: user.id,
    },
    onError: err => {
      logger.warning('Error querying Hasura for breakout session registration', { err })
    },
    skip: !isPageVisible,
  })

  return {
    loading,
    error: error ?? null,
    registration: data?.session_registration?.[0] ?? null,
  }
}
